import { makeVerification } from './makeVerification';

export const verifyFetch = makeVerification('edit_recurly_contact_info');

export const verifyUpdate = makeVerification('edit_recurly_contact_info');
